export default [

     {
          path: '/vulnerability-catalogue',
          name: 'VulnerabilityCatalogue',
          component: () => import("@/views/Page/VulnerabilityCatalogue/VulnerabilityCatalogue.vue"),
           meta: {
               title: 'Cyber Mode | VulnerabilityCatalogue',
          },
     }
];